module.exports = __webpack_public_path__ + "img/Capture5.1631b510.jpg";